/**
 * Utility functions for working with URL parameters.
 * Extracted for testability since window.location mocking is problematic in JSDOM.
 */

export function getUrlParam(paramName: string): string | null {
  if (typeof window === 'undefined') return null;
  return new URL(window.location.href).searchParams.get(paramName);
}

export function clearUrlParam(paramName: string): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  if (url.searchParams.has(paramName)) {
    url.searchParams.delete(paramName);
    window.history.replaceState({}, '', url.toString());
  }
}
